// extracted by mini-css-extract-plugin
export var md = "_4m-4";
export var semantic = "_4m-5";
export var sm = "_4m-3";
export var text = "_4m-6";
export var toggleInput = "_4m-0";
export var toggleSwitch = "_4m-1";
export var xs = "_4m-2";